module.exports = "/_next/static/images/ef07d8332b5d09cad607a813c7c80115-stapler@tablet768.jpg.webp";